/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';
import type { SignatureProgressDto } from './SignatureProgressDto';
import {
    SignatureProgressDtoFromJSON,
    SignatureProgressDtoFromJSONTyped,
    SignatureProgressDtoToJSON,
    SignatureProgressDtoToJSONTyped,
} from './SignatureProgressDto';
import type { ApplicationFormStatus } from './ApplicationFormStatus';
import {
    ApplicationFormStatusFromJSON,
    ApplicationFormStatusFromJSONTyped,
    ApplicationFormStatusToJSON,
    ApplicationFormStatusToJSONTyped,
} from './ApplicationFormStatus';

/**
 * 
 * @export
 * @interface DocumentListItemDto
 */
export interface DocumentListItemDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentListItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentListItemDto
     */
    applicationFormId: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentListItemDto
     */
    applicationFormName: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentListItemDto
     */
    versionNumber: number;
    /**
     * 
     * @type {ApplicationFormStatus}
     * @memberof DocumentListItemDto
     */
    status: ApplicationFormStatus;
    /**
     * 
     * @type {string}
     * @memberof DocumentListItemDto
     */
    organizationId: string;
    /**
     * 
     * @type {UserDto}
     * @memberof DocumentListItemDto
     */
    createdBy: UserDto;
    /**
     * 
     * @type {Date}
     * @memberof DocumentListItemDto
     */
    createdAt: Date;
    /**
     * Total number of versions for this application form
     * @type {number}
     * @memberof DocumentListItemDto
     */
    totalVersionCount: number;
    /**
     * Number of versions of this application form that have been signed
     * @type {number}
     * @memberof DocumentListItemDto
     */
    signedVersionCount: number;
    /**
     * 
     * @type {SignatureProgressDto}
     * @memberof DocumentListItemDto
     */
    signatureProgress?: SignatureProgressDto;
}



/**
 * Check if a given object implements the DocumentListItemDto interface.
 */
export function instanceOfDocumentListItemDto(value: object): value is DocumentListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('applicationFormId' in value) || value['applicationFormId'] === undefined) return false;
    if (!('applicationFormName' in value) || value['applicationFormName'] === undefined) return false;
    if (!('versionNumber' in value) || value['versionNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('totalVersionCount' in value) || value['totalVersionCount'] === undefined) return false;
    if (!('signedVersionCount' in value) || value['signedVersionCount'] === undefined) return false;
    return true;
}

export function DocumentListItemDtoFromJSON(json: any): DocumentListItemDto {
    return DocumentListItemDtoFromJSONTyped(json, false);
}

export function DocumentListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'applicationFormId': json['applicationFormId'],
        'applicationFormName': json['applicationFormName'],
        'versionNumber': json['versionNumber'],
        'status': ApplicationFormStatusFromJSON(json['status']),
        'organizationId': json['organizationId'],
        'createdBy': UserDtoFromJSON(json['createdBy']),
        'createdAt': (new Date(json['createdAt'])),
        'totalVersionCount': json['totalVersionCount'],
        'signedVersionCount': json['signedVersionCount'],
        'signatureProgress': json['signatureProgress'] == null ? undefined : SignatureProgressDtoFromJSON(json['signatureProgress']),
    };
}

export function DocumentListItemDtoToJSON(json: any): DocumentListItemDto {
    return DocumentListItemDtoToJSONTyped(json, false);
}

export function DocumentListItemDtoToJSONTyped(value?: DocumentListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'applicationFormId': value['applicationFormId'],
        'applicationFormName': value['applicationFormName'],
        'versionNumber': value['versionNumber'],
        'status': ApplicationFormStatusToJSON(value['status']),
        'organizationId': value['organizationId'],
        'createdBy': UserDtoToJSON(value['createdBy']),
        'createdAt': ((value['createdAt']).toISOString()),
        'totalVersionCount': value['totalVersionCount'],
        'signedVersionCount': value['signedVersionCount'],
        'signatureProgress': SignatureProgressDtoToJSON(value['signatureProgress']),
    };
}

